export default {
  checkIn: {
    aboutVisit: {
      am: 'am',
      at: 'a',
      choose: 'Scegli',
      hour: 'Ora',
      meridian: 'am/pm',
      min: 'Min',
      pleaseEnterAValidTimeAndDate: "Inserisci un'ora e una data valide",
      pm: 'pm',
      timeCantBeFuture: "La data/l'ora non possono essere nel futuro",
      today: 'Oggi',
      yesterday: 'Ieri'
    },
    checkIn: {
      info: 'Alcune informazioni vanno qui...',
      browserOutdated: "Il tuo browser non è aggiornato. Effettua l'aggiornamento a un {0}browser Web moderno{1}."
    },
    digitalReceipt: {
      currency: '€',
      description: 'Descrizione',
      discount: 'Sconto',
      emailReceipt: 'Invia la ricevuta via e-mail',
      mealReceipt: 'Ricevuta pasto',
      price: 'Prezzo',
      save: 'Salva',
      server: 'Server',
      serviceCharge: 'Costo del servizio',
      tableNumber: 'Numero del tavolo',
      total: 'Totale',
      yourEmail: 'La tua email'
    },
    errors: {
      noSlug: 'Nessun tag sondaggio superato',
      badSlug: 'Utilizzato tag sondaggio errato'
    },
    guestTableNumberEntry: {
      mustBeANumber: 'Il numero del tavolo deve essere un numero',
      pleaseEnterTableNumber: 'Inserisci il numero del tuo tavolo in modo che possiamo trovare il tuo ordine',
      tableNumber: 'Numero del tavolo',
      yourTableNumber: 'Il numero del tuo tavolo'
    },
    locationCheckIn: {
      checkIn: 'Check-in',
      freeDesertOnYourNextVisit: 'Dessert gratuito alla tua prossima visita',
      pleaseTellUsAboutYourExperience: 'Raccontaci la tua esperienza: ci vorrà meno di un minuto!'
    },
    teamMemberReceiptPinEntry: {
      downloadingTransactionData: 'Scaricamento dati della transazione',
      enterPinNumber: 'Inserisci il numero PIN',
      pinNumber: 'Numero PIN'
    },
    teamMemberTableNumberEntry: {
      downloadingTransactionData: 'Scaricamento dati della transazione',
      mustBeANumber: 'Il numero del tavolo deve essere un numero',
      pleaseEnterTableNumber: 'Inserisci il numero del tavolo per scaricare i dati della transazione',
      tableNumber: 'Numero del tavolo',
      noNumber: 'Not Implemented.' // TODO: Translate (PWA)

    }
  }
};